import { iconMap } from '../constants/iconMap';
export const getSeatIconUrl = async (brand, characteristic) => {
  var _iconMap, _await$loadIcon;
  const key = (_iconMap = iconMap[characteristic]) !== null && _iconMap !== void 0 ? _iconMap : 'default';
  const loadIcon = async brandPath => {
    try {
      const icon = await import(`@eti/assets/icons/seating-buttons/${brandPath}/seatButton-${key}.svg?url`);
      return icon.default;
    } catch {
      return undefined;
    }
  };
  const result = (_await$loadIcon = await loadIcon(brand)) !== null && _await$loadIcon !== void 0 ? _await$loadIcon : await loadIcon('default');
  if (!result) {
    // oxlint-disable-next-line no-console
    console.error(`[getSeatIconUrl] Failed to load icon: brand=${brand}, characteristic=${characteristic}`);
  }
  return result;
};
//# sourceMappingURL=getSeatIconUrl.js.map